import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BaseHomePage from "./BasePage";
import { Box, Grid, Typography, Link, CssBaseline } from "@mui/material";
import ViewChatComponent from "../components/ViewChatComponent";
import SceneComponent from "../components/SceneComponent";
import Chat from "../components/Chat";
import event from "../resources/event.json";
import CountdownComponent from "../components/CountdownComponent";
import { AddToCalendarButton } from "add-to-calendar-button-react";

export default function PlayerPage() {
  const location = useLocation();
  const navigate = useNavigate();
  document.title = "Inicio";
  const [data, setData] = useState({
    startAt: String(),
    endAt: String(),
    link: String(),
  });
  const [timeRemaining, setTimeRemaining] = useState(0);

  const renderView = () => {
    return (
      <Box sx={{ m: 12 }}>
        <SceneComponent video={data.link} />
      </Box>
    );
  };

  // const getVideos = useCallback(() => {
  //   let day = new Date().getDate() - new Date(event.startAt).getDate();
  //   let date = event.days[day];

  //   if (date === undefined) {
  //     return;
  //   }

  //   let videos = date.videos.filter(
  //     (video) => new Date(video.endAt).getTime() >= new Date().getTime()
  //   );

  //   if (videos !== undefined) {
  //     if (videos.length === Number()) {
  //       setData({
  //         ...data,
  //         nextVideo: String(),
  //         currentVideo: String(),
  //       });
  //       return;
  //     }
  //     if (new Date() > new Date(videos[0].startAt)) {
  //       setData({ ...data, nextVideo: String(), currentVideo: videos[0].link });
  //     } else {
  //       setData({
  //         ...data,
  //         nextVideo: videos[0].startAt,
  //         currentVideo: String(),
  //       });
  //     }
  //   } else {
  //     setData({
  //       ...data,
  //       nextVideo: String(),
  //       currentVideo: String(),
  //     });
  //   }
  // }, [data]);

  // const renderCountdown = (splitStart, splitEnd) => {
  //   return (
  //     <Box sx={{}}>
  //       <h1 id="lessLabel">FALTAN</h1>
  //       <CountdownComponent date={event.startAt} />
  //       <Link
  //         sx={{ fontSize: 42 }}
  //         href={"https://bit.ly/EXITO_EXPONENCIAL"}
  //         target="_blank"
  //       >
  //         {"REGISTRATE"}
  //       </Link>
  //       <Box sx={{ m: "auto" }}>
  //         <Typography variant="h6">{"Agregalo a tu calendario"}</Typography>
  //         <AddToCalendarButton
  //           name="addToCal"
  //           label="Agrega a tu calendario"
  //           options={[
  //             "Apple",
  //             "Google",
  //             "iCal",
  //             "Microsoft365",
  //             "MicrosoftTeams",
  //             "Outlook.com",
  //             "Yahoo",
  //           ]}
  //           icsFile="https://firebasestorage.googleapis.com/v0/b/culebroapp.appspot.com/o/event.ics?alt=media&token=e5209487-ffe6-4a6d-80de-60fc19a6c4d5"
  //           timeZone="America/Mexico_City"
  //           startDate={event.startAt.split("T")[0]}
  //           endDate={event.endAt.split("T")[0]}
  //           startTime={`${splitStart[0]}:${splitStart[1]}`}
  //           endTime={`${splitEnd[0]}:${splitEnd[1]}`}
  //           buttonsList
  //           hideTextLabelButton
  //           bypassWebViewCheck
  //           buttonStyle="round"
  //         />
  //       </Box>
  //     </Box>
  //   );
  // };

  // const renderSeeYouSoon = () => {
  //   return (
  //     <Box>
  //       <Typography variant="h1">{"¡NOS VEMOS PRONTO!"}</Typography>
  //     </Box>
  //   );
  // };

  // const renderEvent = () => {
  //   if (new Date() > new Date(event.startAt)) {
  //     if (new Date() > new Date(event.endAt)) {
  //       return renderSeeYouSoon();
  //     } else {
  //       return renderView();
  //     }
  //   } else {
  //     let splitStart = event.startAt.split("T")[1].split(":");
  //     let splitEnd = event.endAt.split("T")[1].split(":");
  //     renderCountdown(splitStart, splitEnd);
  //   }
  // };

  const chekckVideoEnded = useCallback(() => {
    if (new Date() > new Date(data.endAt) && timeRemaining === Number()) {
      setTimeRemaining(5);
    }

    if (timeRemaining > Number()) {
      if (timeRemaining - 1 === Number()) {
        navigate("/");
        return;
      }
      setTimeRemaining(timeRemaining - 1);
    }
  }, [data.endAt, timeRemaining, navigate]);

  useEffect(() => {
    const video = location.state ? location.state : null;
    if (video === null) {
      navigate("/");
      return;
    }
    if (data.endAt === String()) {
      setData(video);
    }
  }, [location.state, navigate, data.endAt, chekckVideoEnded]);

  return <BaseHomePage showBack={true}>{renderView()}</BaseHomePage>;
}
